import { render, staticRenderFns } from "./dialog-detailoutbox.vue?vue&type=template&id=5135dd28&"
import script from "./dialog-detailoutbox.vue?vue&type=script&lang=js&"
export * from "./dialog-detailoutbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports